
export function isAdmin(auth) {

  if(!auth)
    return false

  if(auth.email === "khabich@gmail.com" || auth.email === "aidan3dbit@gmail.com" || auth.email === "kevaid@kevaid.com")
    return true // ADMIN ONLY
  else
    return false
}



// WEBPACK FOOTER //
// ./src/utils/admin.js